<template>
  <div class="card" :style="{opacity: cardOpacity}">
    <div class="card__title">
      Ședință <span style="text-transform: capitalize">{{ serviceGroup[0].type }}</span>
    </div>
    <div class="card__counter" :style="counterTransfrom">
      {{serviceGroup.length}}
    </div>
    <div class="card__body">
      <div class="card__metadata">
        <span>
          {{serviceGroup[0].value}}
          <img src="@/assets/images/icons/coins.svg">
        </span>

        {{ servicesDuration }} minute
      </div>
      <div class="card__abstract">
        <i class="card__icon fas fa-id-card" />
      </div>
    </div>

    <button class="card__convert" @click="convertService()">
      Schimbă în credite
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    serviceGroup: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      counterScale: 1,
      cardOpacity: 1
    }
  },
  computed: {
    ...mapGetters({
      servicesDuration: 'services/servicesDuration',
    }),
    counterTransfrom() {
      return `transform: scale(${this.counterScale});`;
    }
  },
  methods: {
    ...mapActions({
      convertServiceAction: 'services/convertService'
    }),
    convertService() {
      if(this.counterScale === 1 && this.serviceGroup.length > 1)
      {
        this.counterScale=1.2;
        this.convertServiceAction(this.serviceGroup[0].id);
        setTimeout(() => {
          this.counterScale = 1;
        }, 1000)
      }
      else if(this.counterScale === 1 && this.serviceGroup.length === 1)
      {
        this.cardOpacity = 0;
        setTimeout(() => {
          this.convertServiceAction(this.serviceGroup[0].id);
        }, 200);
        this.cardOpacity = 1;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background: #FFFFFF;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  height: 140px;
  min-height: 140px;
  margin-right: 0;
  margin-bottom: 20px;
  min-width: 150px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  width: 100%;
  position: relative;
  transition: opacity .3s;

  @include media-breakpoint-up(sm) {
    margin-bottom: 0;
    margin-right: 20px;
    width: 150px;
  }

  &__counter {
    position: absolute;
    height: 25px;
    width: 25px;
    right: 5px;
    top: 5px;
    font-size: 13.333px;
    background-color: $color-primary;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-card;
    transition: all .3s;

    @include media-breakpoint-up(sm) {
      right: -10px;
      top: -5px;
    }

    &--anim {
      animation-name: counter-anim;
      animation-duration: .3s;
      animation-timing-function: ease-in-out;
    }
  }

  &__title {
    color: $color-gray;
    border-bottom: 1px solid $color-light-gray;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
    padding-bottom: 5px;
  }

  &__body {
    color: $color-gray;
    display: flex;
  }

  &__metadata {
    color: $color-gray;
    flex: 1;
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    line-height: 1;

    & > span {
      color: #F2BC36;
      display: block;
      line-height: 1.5;
    }
  }

  &__abstract {
    background: $gradient-nexyo;
    height: 38px;
    width: 48px;
  }

  &__icon {
    color: #ffffff;
    font-size: 48px;
    font-weight: 400;
    left: -2px;
    position: relative;
    top: -5px;
  }

  &__convert {
    background: $color-primary;
    border: 2px solid transparent;
    color: #ffffff;
    cursor: pointer;
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: auto;
    padding-bottom: 2px;
    padding-top: 2px;
    transition: 100ms color, 100ms border-color, background 100ms;

    &:hover {
      background: #ffffff;
      border: 2px solid $color-primary;
      color: $color-primary;
    }
  }
}

@keyframes counter-anim {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
